import {
    FETCH_ADMIN_MESSAGES,
    FETCH_ADMIN_MESSAGES_SUCCESS,
    FETCH_ADMIN_MESSAGES_FAILED,
    SEND_ADMIN_MESSAGE,
    FETCH_CHAT_READ_SUCCESS,
    UPDATE_ADMIN_CHAT_STATUS
} from "../store/types";

const INITIAL_STATE = {
    chats: null,
    reads: null,
    status: null,
    operatorRequested: false,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const admchatreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ADMIN_MESSAGES:
            return {
                ...state,
                loading: true
            };
        case FETCH_CHAT_READ_SUCCESS:
            return {
                ...state,
                reads: action.payload,
                loading: false
            };
        case FETCH_ADMIN_MESSAGES_SUCCESS:
            if (action.payload && !Array.isArray(action.payload) && action.payload.messages !== undefined) {
                return {
                    ...state,
                    chats: action.payload.messages,
                    status: action.payload.status || null,
                    operatorRequested: Boolean(action.payload.operatorRequested),
                    loading: false
                };
            }
            return {
                ...state,
                chats: action.payload,
                loading: false
            };
        case UPDATE_ADMIN_CHAT_STATUS:
            return {
                ...state,
                status: action.payload?.status || null,
                operatorRequested: Boolean(action.payload?.operatorRequested)
            };
        case FETCH_ADMIN_MESSAGES_FAILED:
            return {
                ...state,
                chats: null,
                reads: null,
                status: null,
                operatorRequested: false,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case SEND_ADMIN_MESSAGE:
            return state;
        default:
            return state;
    }
};